// Deriva os campos de exibição de um ticket REAL do Whaticket para a lista/header.
// Timer/SLA contam só o tempo que o CLIENTE está esperando resposta: começam na
// 1ª mensagem recebida não respondida (awaitingSince) e ficam neutros quando a
// última mensagem foi do atendente (lastFromMe) — dados vindos do backend.

import {
  TAGS,
  CH,
  fmtTimer,
  slaState,
  SLA,
  attendantColor,
  initials as initialsOf,
} from "../../CrmKanban/kanban/tokens";

// O ticket está aguardando resposta nossa? (cliente mandou algo sem retorno)
export const isAwaiting = (ticket) =>
  !ticket?.lastFromMe && !!ticket?.awaitingSince;

// Minutos de espera do cliente (desde awaitingSince). 0 se já respondido.
export const ticketMins = (ticket) => {
  if (!isAwaiting(ticket)) return 0;
  const t = new Date(ticket.awaitingSince).getTime();
  if (Number.isNaN(t)) return 0;
  return Math.max(0, (Date.now() - t) / 60000);
};

// Chip de SLA/timer. Closed -> "Resolvido"; já respondido -> "em dia" neutro;
// aguardando -> timer da espera do cliente.
export const slaChip = (ticket, slaLimite) => {
  if (ticket?.status === "closed") {
    return { bg: "#E9F8EF", text: "#1E7A46", label: "Resolvido" };
  }
  if (!isAwaiting(ticket)) {
    const [bg, text] = SLA.ok;
    return { bg, text, label: "em dia" };
  }
  const mins = ticketMins(ticket);
  const st = slaState(mins, slaLimite, ticket?.status === "open");
  const [bg, text] = SLA[st];
  return { bg, text, label: fmtTimer(mins) };
};

// Hora curta HH:MM de uma data ISO (ou "" se ausente).
export const shortTime = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return (
    String(d.getHours()).padStart(2, "0") +
    ":" +
    String(d.getMinutes()).padStart(2, "0")
  );
};

// Tag (chip) — do lead se carregado, senão null.
export const tagChip = (tag) => {
  if (!tag || !TAGS[tag]) return null;
  const [color, bg] = TAGS[tag];
  return { label: tag, color, bg };
};

// Canal (dot) — do lead se carregado, senão null.
export const chDot = (channel) => {
  if (!channel || !CH[channel]) return null;
  const [label, color] = CH[channel];
  return { label, color };
};

// Preview da última mensagem. Prefixa "Você: " quando fromMe.
export const previewOf = (ticket) => {
  const last = ticket?.lastMessage || "";
  if (!last) return "";
  return last;
};

// Rótulo do status (aba Busca mostra chip).
export const statusLabel = (status) => {
  if (status === "open") return "Atendendo";
  if (status === "pending") return "Aguardando";
  if (status === "closed") return "Resolvido";
  return "";
};

export { attendantColor, initialsOf };
